export enum AuthProvider {
  Email,
  Google,
}
